module.exports = __webpack_public_path__ + "img/weddings_07_V.560f4f67.webp";